export const activityStepTypes = [
  "text",
  "image",
  "video",
  "timer",
  "upload",
  "qa",
] as const;

export type ActivityStepType = (typeof activityStepTypes)[number];

export interface ActivityStepDraft {
  id: string;
  type: ActivityStepType;
  text: string;
  imageName: string;
  url: string;
}

export const activityStepTypeLabels: Record<ActivityStepType, string> = {
  text: "Text",
  image: "Image",
  video: "Video",
  timer: "Timer",
  upload: "Upload",
  qa: "Q&A",
};

let nextStepId = 0;

export function createActivityStep(
  overrides: Partial<ActivityStepDraft> = {},
): ActivityStepDraft {
  nextStepId += 1;
  return {
    id: `activity-step-${nextStepId}`,
    type: "text",
    text: "",
    imageName: "",
    url: "",
    ...overrides,
  };
}
